// src/components/UI/Modal.js
import React, { useEffect } from 'react';
import GlassCard from './GlassCard';
import { X } from 'lucide-react';

const Modal = ({ show, onClose, title, children, footer, size = 'md' }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [show]);

  if (!show) return null;

  const widthClasses = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl'
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 lg:p-8 animate-in fade-in duration-300">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-md transition-opacity" 
        onClick={onClose}
      ></div>

      {/* Modal Content */}
      <div className={`w-full ${widthClasses[size]} relative z-10 animate-in zoom-in-95 slide-in-from-bottom-4 duration-300`}>
        <GlassCard padding="0" hover={false} className="overflow-hidden border-white/20 shadow-2xl">
          {/* Header */}
          <div className="px-8 py-6 flex items-center justify-between border-b border-white/10 bg-white/5">
            <h2 className="text-2xl font-bold tracking-tight">{title}</h2>
            <button 
              onClick={onClose}
              className="p-2 rounded-xl hover:bg-white/10 text-white/50 hover:text-white transition-all scale-100 active:scale-95"
            >
              <X size={24} />
            </button>
          </div>

          {/* Body */}
          <div className="px-8 py-8 max-h-[75vh] overflow-y-auto custom-scrollbar bg-slate-900/40">
            {children}
          </div>

          {/* Footer */}
          {footer && (
            <div className="px-8 py-6 border-t border-white/10 bg-white/5">
              {footer}
            </div>
          )}
        </GlassCard>
      </div>
      
      <style dangerouslySetInnerHTML={{ __html: `
        .custom-scrollbar::-webkit-scrollbar { width: 6px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { 
          background: rgba(255,255,255,0.1); 
          border-radius: 10px; 
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.2); }
      `}} />
    </div>
  );
};

export default Modal;
